import { setBackendUrl, setAuthUrl, setDevMode, securelyCall } from "@securely.id/websdk";
import { startFirebase } from "./firebase/start.js";
import { loadingSpinner, errorPopup, refreshTooltips } from "./utils.js";
import { prettyAddress } from "./ethereum/utils.js";
import { connect, providerInit, onWalletConnect, getSigner, getChainId } from "./ethereum/wallet.js";
import { ERC1967ProxyAbi, ERC1967ProxyBytecode } from "./ethereum/contracts/abis/erc1967-proxy.js";
import { SecurelyRegistryAbi, SecurelyRegistryAddress } from "./ethereum/contracts/abis/securely-registry.js";
const ethers = require('ethers');

var dAppAbi;
var policies = [];
var tooltips = {};
var complianceProxy;
var accessToken;

onWalletConnect(async () => {
    const chainId = await getChainId();
    $(`#chain-${chainId}`).prop('selected', true); // Select the chain in the dropdown
    $('#submit-step4').prop('disabled', false);
});

function addPolicySelection(fragment=undefined) {
    const sighash = fragment === undefined ? 'UserPolicy' : fragment.selector.replace(/^0x/, '');
    const sigfull = fragment === undefined ? 'User policy' : fragment.format('full');
    const pretty = fragment === undefined ?
        `User policy <i
            class="fa-solid fa-circle-info"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-html="true"
            data-bs-container="body"
            title="The user policy is included in every other policy<br />
                and can be triggered before making any transaction.<br />
                It is a set of rules that apply to all users of your DApp.<br />
                This is typically where you would put KYC/KYB checks."
        ></i>`
        : fragment.format('full');
    $('#policies-selection').append(`
        <div class="mt-5 mb-4 row text-start" id="function-${sighash}">
            <div class="col-6"><h6>${pretty}</h6></div>
            <div class="col-5">
                <select class="form-select" id="function-${sighash}-policies">
                    <option value="" selected>No policy</option>
                </select>
            </div>
            <div class="col-1 info-container">
                <i
                    id="function-${sighash}-info"
                    class="fa-solid fa-circle-info info disabled-info"
                ></i>
            </div>
        </div>
    `);
    const policyDescriptions = {
        'KYT Only': 'Chainalysis risk score must be equal to 0',
        'KYC Synaps WebAuthn': 'KYC check the user with Synaps and require French citizenship',
        'IP Location FR': 'Requires a French IP (provider: IP API)',
    };
    for (let policyName of Object.keys(policyDescriptions)) {
        const policySlug = policyName.toLowerCase().replaceAll(' ', '_').replaceAll('+', '');
        $(`#function-${sighash}-policies`).append(`<option value="${policySlug}">${policyName}</option>`);
    }
    $(`#function-${sighash}-policies`).on('change', function() {
        const policyName = $(this).find(":selected").text();
        const policyDescription = policyDescriptions[policyName];
        if (tooltips[sighash] === undefined) {
            tooltips[sighash] = new bootstrap.Tooltip($(`#function-${sighash}-info`), {
                placement: "top",
                title: policyDescription,
                trigger: "hover",
                html: true
            });
            $(`#function-${sighash}-info`).removeClass('disabled-info');
        } else if (policyName == 'No policy') {
            tooltips[sighash].dispose();
            tooltips[sighash] = undefined;
            $(`#function-${sighash}-info`).addClass('disabled-info');
        } else {
            tooltips[sighash].setContent({'.tooltip-inner': policyDescription});
            $(`#function-${sighash}-info`).removeClass('disabled-info');
        }
    });
    policies.push([sigfull, sighash]);
}

async function deployAndInitializeProxy() {
    const signer = await getSigner();
    $('#chain').html($('#network-select option:selected').text());

    // This is a valid compliance proxy address on Sepolia.
    // Uncomment next line to be able to test the frontend without actually deploying anything.
    // return '0x4Fee4aC80923FcCbfad1f745bFc690f23Ac955b3';

    const ProxyFactory = new ethers.ContractFactory(ERC1967ProxyAbi, ERC1967ProxyBytecode, signer);
    const securelyRegistry = new ethers.Contract(SecurelyRegistryAddress, SecurelyRegistryAbi, signer);
    var complianceImpl;
    try {
        complianceImpl = await securelyRegistry.getRecord(await securelyRegistry.COMPLIANCE_DEFAULT_IMPL());
    } catch (error) {
        errorPopup(`Unable to fetch the default compliance implementation: ${error}`);
        return undefined;
    }
    var proxyContract;
    try {
        proxyContract = await ProxyFactory.deploy(complianceImpl);
    } catch (error) {
        errorPopup(`Unable to deploy the proxy: ${error}`);
        return undefined;
    }

    // Uncomment next line if you feel like we need to confirm the proxy deployment. Probably useless.
    // await proxyContract.waitForDeployment();
    return proxyContract.target;
}

$(document).ready(function() {
    window.setBackendUrl = setBackendUrl;
    window.setAuthUrl = setAuthUrl;
    window.setDevMode = setDevMode;
    refreshTooltips();
    var providerInitialized = false;

    const auth = startFirebase('#firebaseui-auth-container', '#');
    auth.onAuthStateChanged(function(user) {
        console.log('onAuthStateChanged', user);
        if (user) {
            $('#firebase-auth-false').hide();
            $('#email-input').val(user.email);
            $('#firebase-auth-true').show();
            console.log(user);
            if (user.photoURL) {
                $('#user-card').html(`
                    <div id="user-photo-container" class="float-end">
                        <img id="user-photo" src="${user.photoURL}" alt="User photo" />
                    </div>
                    <div id="logout-card" class="float-end">
                        <button class="btn btn-secondary" id="logout-link">Logout</a>
                    </div>
                `);
            } else {
                $('#user-card').html(`
                    <div id="user-email-container" class="float-end">
                        <p id="user-photo">Logged as<br />${user.email}</p>
                    </div>
                    <div id="logout-card" class="float-end">
                        <button class="btn btn-secondary" id="logout-link">Logout</a>
                    </div>
                `);
            }
            $('#user-photo').click(function() {
                $('#logout-card').toggle();
            });
            $('#logout-link').click(function() {
                auth.signOut();
                $('#user-card').html('');
                window.location.reload();
            });
            accessToken = user.multiFactor.user.accessToken;
        } else {
            $('#firebase-auth-true').hide();
            $('#firebase-auth-false').show();
        }
    }, console.error);

    // Step 1
    $('#step1-form').on('submit', function(e) {
        e.preventDefault();
        $('#step1').hide();
        $('#step2').show();
    });

    // Step 2
    $('#step2-form').on('submit', function(e) {
        e.preventDefault();
        dAppAbi = $('#dapp-abi-input').val();
        addPolicySelection();
        $('#policies-selection').append(`<hr />`);
        try {
            for (let fragment of new ethers.Interface(dAppAbi).fragments)
                if (fragment.type === 'function' && !fragment.constant)
                    addPolicySelection(fragment);
        } catch(error) {
            errorPopup(`Unable to parse the ABI: ${error}`);
            $('#policies-selection').empty();
            policies = [];
            tooltips = {};
            return;
        }
        refreshTooltips();
        $('#step2').hide();
        $('#step3').show();
    });
    $('#step2-form .back-button').on('click', function() {
        $('#step2').hide();
        $('#step1').show();
    });

    // Step 3
    $('#step3-form').on('submit', function(e) {
        e.preventDefault();
        $('#step4-summary').html(`
            <table class="table table-bordered">
                <thead class="thead">
                    <tr><th colspan="2" class="text-center bold">Your informations</td></tr>
                </thead>
                <tbody>
                    <tr><td>Email</td><td>${$('#email-input').val()}</td></tr>
                </tbody>
            </table>
            <table class="table table-bordered">
                <thead class="thead">
                    <tr><th colspan="2" class="text-center bold">Policies</td></tr>
                </thead>
                <tbody id="policies-summary">
                </tbody>
            </table>
        `);
        for (let [sigfull, sighash] of policies) {
            const policy = $(`#function-${sighash}-policies`).find(":selected").val();
            if (policy.length != 0)
                $('#policies-summary').append(`<tr><td>${sigfull}</td><td>${policy}</td></tr>`);
        }
        $('#step3').hide();
        $('#step4').show();
        if (!providerInitialized) {
            providerInitialized = true;
            const searchParams = new URLSearchParams(window.location.search);
            const wallet = searchParams.has('wallet') ? searchParams.get('wallet') : 'metamask';
            providerInit(wallet);
            $('#network-select').on('change', async function() {
                complianceProxy = undefined;
                try {
                    const signer = await getSigner();
                    await signer.provider.send('wallet_switchEthereumChain', [{ chainId: `0x${BigInt($(this).val()).toString(16)}` }]);
                    connect();
                } catch (switchError) {
                    errorPopup(switchError.message);
                    $('#chain-undefined').prop('selected', true);
                }
            });
            if (window.ethereum) {
                // Update the dropdown to reflect a chain change in the wallet
                window.ethereum.on('chainChanged', (chainId) => {
                    $(`#chain-${parseInt(chainId, 16)}`).prop('selected', true);
                });
            }
        }
    });
    $('#step3-form .back-button').on('click', function() {
        $('#step3').hide();
        $('#policies-selection').empty();
        policies = [];
        tooltips = {};
        $('#step2').show();
    });

    // Step 4
    $('#step4-form').on('submit', async function(e) {
        e.preventDefault();
        const submitButtonContent = $('#submit-step4').html();
        $('#submit-step4').prop('disabled', true);
        $('#submit-step4').html(loadingSpinner);
        if (complianceProxy === undefined)
            complianceProxy = await deployAndInitializeProxy();
        if (complianceProxy === undefined)
            return;
        $('#compliance-proxy-address').html(prettyAddress(complianceProxy));
        refreshTooltips();
        $('#step4').hide();
        $('#tada1').hide();
        $('#step5').show();
        $('#tada1').show("slow");
        $('#submit-step4').prop('disabled', false);
        $('#submit-step4').html(submitButtonContent);
    });
    $('#step4-form .back-button').on('click', function() {
        $('#step4').hide();
        $('#step3').show();
    });

    // Step 5
    $('#step5-form').on('submit', async function(e) {
        e.preventDefault();
        $('#submit-step5').prop('disabled', true);
        $('#submit-step5').html(loadingSpinner);
        const selectedPolicies = {};
        const chainId = $('#network-select option:selected').val();
        $('#dapp').html(prettyAddress($('#dapp-address-input').val()));
        $('#compliance-proxy').html(prettyAddress(complianceProxy));
        refreshTooltips();
        const dapp = $('#dapp-address-input').val().toLowerCase().replace(/^0x/, '');
        for (let [_, sighash] of policies) {
            const policySelector = sighash == 'UserPolicy' ? `${chainId}-${dapp}` : `${chainId}-${dapp}-${sighash}`;
            const policy = $(`#function-${sighash}-policies`).find(":selected").val();
            if (policy.length != 0)
                selectedPolicies[policySelector] = policy;
        }
        const params = {
            dAppId: complianceProxy.toLowerCase().replace(/^0x/, ''),
            abi: dAppAbi,
            email: $('#email-input').val(),
            notifyIfApproved: $('#notify-approved').is(':checked'),
            notifyIfApprovalRequired: $('#notify-manual-approval').is(':checked'),
            notifyIfRejected: $('#notify-rejected').is(':checked'),
            policies: selectedPolicies,
        };
        try {
            await securelyCall('onboard', 'builder', params, accessToken);
        } catch (error) {
            errorPopup(error);
            return;
        } finally {
            $('#submit-step5').prop('disabled', false);
            $('#submit-step5').html('Finalize');
        }
        $('#step5').hide();
        $('#tada2').hide();
        $('#step6').show();
        $('#tada2').show("slow");
        party.confetti(document.querySelector("#tada2"), {
            count: party.variation.range(100, 200),
            size: party.variation.range(0.4, 0.8),
        });
    });
    $('#step5-form .back-button').on('click', function() {
        $('#step5').hide();
        $('#step4').show();
    });
});
